import { render, staticRenderFns } from "./GameDetailsModal.vue?vue&type=template&id=4f34a636&"
import script from "./GameDetailsModal.vue?vue&type=script&lang=js&"
export * from "./GameDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports